export default {"src":"/_next/static/media/business.7c018a54.svg","height":30,"width":24};